import React from 'react';
import Icon from '../../../components/AppIcon';

const SummaryCards = ({ summary = {}, loading = false }) => {
  const formatCurrency = (value) => {
    return `$${value?.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  const cards = [
    {
      icon: 'DollarSign',
      label: 'Ingresos Totales',
      value: formatCurrency(summary?.totalRevenue || 0),
      color: 'success'
    },
    {
      icon: 'FileCheck',
      label: 'Órdenes Completadas',
      value: summary?.totalOrders || 0,
      color: 'primary'
    },
    {
      icon: 'TrendingUp',
      label: 'Valor Promedio',
      value: formatCurrency(summary?.averageOrderValue || 0),
      color: 'warning'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {cards?.map((card) => (
        <div 
          key={card?.label}
          className="bg-card rounded-lg border border-border shadow-sm p-4 hover:shadow-md transition-smooth"
        >
          {loading ? (
            <div className="flex justify-center items-center h-20">
              <Icon name="Loader2" className="w-6 h-6 text-blue-600 animate-spin" />
            </div>
          ) : (
            <>
              <div className="flex items-center gap-3 mb-2">
                <div className={`p-2 rounded-lg bg-${card?.color}/10`}>
                  <Icon name={card?.icon} size={24} className={`text-${card?.color}`} />
                </div>
                <span className="text-sm text-muted-foreground">{card?.label}</span>
              </div>
              <div className="text-2xl font-bold text-foreground">
                {card?.value}
              </div>
            </>
          )}
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;